
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"shp0",attrs:{"fill-rule":"evenodd","d":"M34.8 96.1c0 6-4.8 10.9-10.8 10.9-6 0-10.9-4.9-10.9-10.9C13.1 90 18 85.2 24 85.2S34.8 90 34.8 96.1zm-5.1-.1c0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7s5.7-2.5 5.7-5.7zM132.4 96.1c0 6-4.9 10.9-10.9 10.9s-10.9-4.9-10.9-10.9c0-6.1 4.9-10.9 10.9-10.9s10.8 4.8 10.9 10.9zm-5.2-.1c0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7s5.6-2.5 5.7-5.7z"}}),_c('path',{staticClass:"shp0",attrs:{"fill-rule":"evenodd","d":"M160.3 95.9l-25.2.7s-1.7-13.2-13.9-13.2c0 0-12.6.3-13 15.3H37.1s.4-15.2-12.5-15.2c0 0-13.4 0-13.4 13.4 0 0-4.2.7-6-3.8 0 0-3.5.1-3.5-2.3 0 0-.3-2.8 2.9-2.7V80s.7-3.8 7.6-3.9L47 73.9l3-2.8 10.9-10.2s2.5-3 6.3-3.3c0 0 7.8-.4 17.1-.5 3.6-.1 7.4-.1 11 0 5.7.1 11 .5 14.5 1.1 0 0 4.6.5 7.8 3.3l8.1 6.8 6.6 5.6 24.8 3.6 3.1 6.1-2 7.1s3.7.4 4.1 2.2c0 0 .5 2.7-2 3zM85.5 72.3v-9.6c0-1.4-1.9-1.8-1.9-1.8H67.9c-1 0-2.8 1.2-2.8 1.2l-9.2 9-2.9 2.8h30.4c1.5 0 2-1.2 2.2-1.6 0 .1 0 0 0 0h-.1zm5.6 1.5h30.3l-5.4-5.3-6.7-6.5s-1.8-1.2-2.8-1.2H90.8s-1.9.5-1.9 1.8v9.7s.5 1.6 2.2 1.6v-.1z"}})])
          )
        }
      }
    